import hotkeys from 'hotkeys-js'

export function addHotkey(hotkey: string, action: () => void) {
  hotkeys(hotkey, { keyup: true }, e => {
    e.preventDefault()
    action()
  })
}
